export enum PORTABILITE_FIELDS {
	COVER = 'couvertureANI',
	MAINTENIR_PORTABILITE = 'maintenirPortabilite',
	DATE_DEBUT = 'dateDebut',
	DATE_FIN = 'dateFin',
	FILES = 'files',
	MOTIF = 'motif'
}